import { Box, Heading } from "@chakra-ui/layout";
import React from "react";
import SignupModel from "../Components/signup/SignupSetUp";

const Signup = () => {
  return (
    <Box>
      <SignupModel />
    </Box>
  );
};

export default Signup;
